import moreBySagas from './lineups/more-by/sagas'

export default function sagas() {
  return [...moreBySagas()]
}
